import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Convierte una fecha a formato 'DD/MM/YYYY'.
 * @param value Fecha en cualquier formato aceptado por `Date`.
 * @returns string en formato 'DD/MM/YYYY'.
 */
export function formatearFechaISOaDDMMYYYY(iso: string): string {
  // Espera formato ISO como: "2025-08-01T00:00:00.000Z"
  const [fecha] = iso.split("T"); // "2025-08-01"
  const [año, mes, dia] = fecha.split("-");
  return `${dia}/${mes}/${año}`;
}

/**
 * Calcula el total de aprendices de un cliente final.
 * @param cliente Objeto cliente final con programas y sus contadores de aprendices.
 * @returns Número total de aprendices.
 */
export function calcularTotalAprendicesUnicos(cliente: {
  programa: { aprendizPrograma: { idAprendiz: number }[] }[];
}): number {
  const aprendizIds = new Set<number>();

  if (!cliente.programa || cliente.programa.length === 0) {
    return 0;
  }

  cliente.programa.forEach((programa) => {
    programa.aprendizPrograma.forEach((ap) => {
      aprendizIds.add(ap.idAprendiz);
    });
  });

  return aprendizIds.size;
}
